<table class="myDpYearTable" [ngClass]="{'ng-myrtl': opts.rtl, 'myDpFooter': opts.showFooterToday, 'myDpNoFooter': !opts.showFooterToday, 'myDpViewChangeAnimation': opts.viewChangeAnimation && viewChanged}">
  <tbody>
    @for (yr of years; track $index) {
      <tr>
        @for (y of yr; track $index) {
          <td
            id="y_{{y.row}}_{{y.col}}"
            class="y_{{y.row}}_{{y.col}} myDpYearcell"
            [ngClass]="{'myDpSelectedYear': y.selected, 'myDpDisabled': y.disabled, 'myDpTableSingleYear': !y.disabled}"
            [attr.aria-current]="y.currYear ? 'date' : null"
            [attr.aria-disabled]="y.disabled || null"
            [attr.aria-selected]="y.selected || null"
            [attr.tabindex]="!y.disabled ? 0 : -1"
            (click)="onYearCellClicked($event, y)"
            (keydown)="onYearCellKeyDown($event, y)">
            <span class="myDpYearValue"
              [attr.aria-label]="[(1 + '/' + 1 + '/' + y.year | date:'yyyy')]"
            [ngClass]="{'myDpMarkCurrYear': y.currYear && opts.markCurrentYear}">{{y.year}}</span>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
